import type { State } from '@frontend/state';
import type { SessionType } from '@phi/authentication/frontend';
import type { Ref } from 'vue';
import { minutes } from '@phi/util';
import { Interval as DefaultInterval } from '@phi/util/timeout';

export const periodic_log_factory = (
    state: State,
    session_type: Ref<Set<SessionType>>,
    logger: (event: string, data: string | number) => void,
    Interval = DefaultInterval,
) => {
    const period = minutes(3);
    let loop_count = 0;

    function commit_periodic_log() {
        loop_count++;
        const now = Date.now();
        const idle = now - state.activity_timestamp >= period;
        const session = Array.from(session_type.value).join(' & ');
        if (session_type.value.size === 0)
            return;
        else if (idle) {
            logger(`${session} session idle`, loop_count * period / 1000);
            console.debug('User activity log idle');
        } else {
            logger(`${session} session active`, loop_count * period / 1000);
            console.debug('User activity log active');
        }
    }

    return new Interval(commit_periodic_log, period).start();
};
